module.exports = __webpack_public_path__ + "static/media/Mozilla_Firefox_120.82f2d658.png";


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/assets/img/navegadores/Mozilla_Firefox_120.png
// module id = 2319
// module chunks = 0